import { render, staticRenderFns } from "./SetUserDept.vue?vue&type=template&id=c4838c68&scoped=true&"
import script from "./SetUserDept.vue?vue&type=script&lang=js&"
export * from "./SetUserDept.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4838c68",
  null
  
)

export default component.exports